import { ApiCall } from '../helper/axios';
const BASE = '/api/meeting-agenda';
const meetingAgendaService = {
    listAgendas(params = {}, token) {
        return ApiCall('GET', `${BASE}/agendas`, params, {
            Authorization: token || '',
        });
    },
    createAgenda(payload, token) {
        return ApiCall('POST', `${BASE}/agendas`, payload, {
            Authorization: token || '',
        });
    },
    /**
     * Generates the two weekly-call documents with Claude. Long-running (the
     * model writes two full documents), but well inside ApiCall's 7-minute
     * default timeout.
     */
    /** Polled by the list while a preparation is queued or processing. */
    getAgendaJobStatus(agendaId, token) {
        return ApiCall('GET', `${BASE}/agendas/${agendaId}/job`, '', {
            Authorization: token || '',
        });
    },
    /**
     * Saves hand-edited documents back over the generated ones. Takes a list
     * so both tabs can be committed in a single call, under one edited_at.
     */
    updateAgendaDocument(agendaId, documents, token) {
        return ApiCall('PATCH', `${BASE}/agendas/${agendaId}/document`, { documents }, { Authorization: token || '' });
    },
    /**
     * Downloads one prepared document as a Word file. Returns the raw blob —
     * the caller turns it into a save, since the filename comes from the
     * server's Content-Disposition.
     */
    downloadAgendaDocx(agendaId, doc, token) {
        return ApiCall('GET', `${BASE}/agendas/${agendaId}/download?doc=${doc}`, '', { Authorization: token || '' }, 7 * 60 * 1000, 'blob');
    },
    prepareAgenda(agendaId, token) {
        return ApiCall('POST', `${BASE}/agendas/${agendaId}/prepare`, {}, {
            Authorization: token || '',
        });
    },
    getAgendaById(agendaId, token) {
        return ApiCall('GET', `${BASE}/agendas/${agendaId}`, '', {
            Authorization: token || '',
        });
    },
    deleteAgenda(agendaId, token) {
        return ApiCall('DELETE', `${BASE}/agendas/${agendaId}`, '', {
            Authorization: token || '',
        });
    },
    /**
     * Latest Fireflies meetings for a client (drawer accordion), limited to the
     * date range picked in the drawer. Dates are YYYY-MM-DD.
     */
    getClientMeetings(clientId, token, range) {
        const params = range?.start && range?.end
            ? { start: range.start, end: range.end }
            : '';
        return ApiCall('GET', `${BASE}/clients/${clientId}/meetings`, params, {
            Authorization: token || '',
        });
    },
    getVisibleClients(token) {
        return ApiCall('GET', '/api/visible-clients', '', {
            Authorization: token || '',
        });
    },
};
export default meetingAgendaService;
